import { LinearPoolInfo, LinearStakingData } from "../entities/LinearStaking";
import { formatUnits } from "@ethersproject/units";
import { useActiveWeb3React } from "./useActiveWeb3React";
import { usePoolInfo } from "./useContract";
import { useState } from "react";
import { useResultContract } from "./useResultContract";
import useDebounce from "./useDebounce";

export function useStakingPoolInfos(): undefined | LinearPoolInfo[] {

  const { chainId, account } = useActiveWeb3React();

  const DEFAULT_CHAINID = Number(process.env.NEXT_PUBLIC_CHAINID);

  const poolInfo = usePoolInfo();

  const [resultPoolInfos, setResultPoolInfos] = useState<any[]>([]);

  const info = async () => {

    try {
      const linearPromises = account && DEFAULT_CHAINID === chainId ? await poolInfo.linearPoolViews() : await poolInfo.linearPoolViews().call()
      if (!account) {
        setResultPoolInfos(linearPromises);
        return;
      }
      if (linearPromises && linearPromises.length > 0) {
        const resultArray = await Promise.all(
          linearPromises.map(async (pool, idx) => {
            let linearStakingViewsRaw = await poolInfo.linearStakingViews(idx, account);
            let linearStakingViews: LinearStakingData[] = []
            if (DEFAULT_CHAINID === chainId) {
              linearStakingViews = linearStakingViewsRaw.map((x: LinearStakingData) => ({
                amount: x?.amount ? formatUnits(x.amount, 18) : '0',
                reward: x?.reward ? formatUnits(x.reward, 18) : '0',
                stakeTime: x?.stakeTime ? formatUnits(x.stakeTime, 0) : '0',
                unstakeTime: x?.unstakeTime ? formatUnits(x.unstakeTime, 0) : '0',
                withdrawTime: x?.withdrawTime ? formatUnits(x.withdrawTime, 0) : '0',
                applicableAt: x?.applicableAt ? formatUnits(x.applicableAt, 0) : '0',
                status: x?.status
              }));
            }

            return { ...pool, linearStakingViews };
          })
        );

        setResultPoolInfos(resultArray);
      }

    } catch (error) {
      console.error('Error fetching staking pool infos:', error);
    }
  };

  useResultContract(info, [chainId, account]);

  const debouncedState = useDebounce(resultPoolInfos, 1000);
  return buildPoolInfosOutParams(debouncedState);
};

function buildPoolInfosOutParams(pools: any[]): LinearPoolInfo[] {
  if (!pools) return [];

  const poolInfos = pools && pools.map((d, idx) => ({
    id: idx,
    cap: formatUnits(d?.cap, 18),
    totalStaked: formatUnits(d?.totalStaked, 18),
    minInvestment: d?.minInvestment ? formatUnits(d?.minInvestment, 18) : undefined,
    maxInvestment: formatUnits(d?.maxInvestment, 18),
    APR: formatUnits(d?.APR, 0),
    lockDuration: formatUnits(d?.lockDuration, 0),
    delayDuration: formatUnits(d?.delayDuration, 0),
    startJoinTime: formatUnits(d?.startJoinTime, 0),
    endJoinTime: formatUnits(d?.endJoinTime, 0),
    emergencyAPR: formatUnits(d?.emergencyAPR, 0),
    allowEmergencyWithdraw: d?.allowEmergencyWithdraw,
    linearStakingViews: d?.linearStakingViews,
  }));

  return poolInfos.sort((a, b) => Number(a.lockDuration) - Number(b.lockDuration));
}

